<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition">

    <v-card>
      <v-card-title class="headline white--text primary">
        New Research Document
      </v-card-title>
      <v-card-text>

        <form class="mt-4">
          <v-text-field
            v-model="newResearchDoc.url"
            :error-messages="urlErrors"
            label="URL"
            placeholder="The URL to the page you want to save"
            @input="$v.newResearchDoc.url.$touch()"
            @blur="$v.newResearchDoc.url.$touch()"
          ></v-text-field>

          <v-text-field
            v-model="newResearchDoc.name"
            :error-messages="nameErrors"
            :counter="100"
            label="Name"
            required
            placeholder="Give this research link a name"
            @input="$v.newResearchDoc.name.$touch()"
            @blur="$v.newResearchDoc.name.$touch()"
          ></v-text-field>
        </form>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>

        <v-btn
          color="primary"
          :disabled="$v.newResearchDoc.url.$invalid || creating"
          :loading="creating"
          @click="createNewResearchDoc()"
        >
          Save Link
        </v-btn>

        <v-btn text @click="$v.$reset(); dialog = false;">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Constants from '../constants.json'
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
import axios from 'axios'

// vuelidate
import { validationMixin } from 'vuelidate'
import { url, required, maxLength } from 'vuelidate/lib/validators'

// Custom mixins
import guid from '@/mixins/DecidedlyGUID.js'

import { mapState, mapGetters } from 'vuex'

// import OptionReviewCard from '@/components/OptionReviewCard.vue'

export default {
  name: 'CreateOptionDialog',
  mixins: [validationMixin, guid],
  validations: {
    newResearchDoc: {
      url: { required, url },
      name: { maxLength: maxLength(100) }
    }
  },
  props: {
    value: Boolean,
    // decisionId: String,
    // decisionTaxon: String,
    // decisionCriteria: Object
  },
  mounted: function () {
    this.resetDialog()
  },
  computed: {
    ...mapGetters('decision',{
      criteriaList: 'criteriaList'
    }),
    ...mapState({
      decisionId: state => state.decision.decisionId,
      decisionTaxon: state => state.decision.currentTaxon
    }),
    dialog: {
      // getter
      get: function () {
        return this.value
      },
      // setter
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    },
    urlErrors () {
      const errors = []
      if (!this.$v.newResearchDoc.url.$dirty) return errors
      !this.$v.newResearchDoc.url.url && errors.push('Must be valid URL')
      !this.$v.newResearchDoc.url.required && errors.push('A URL is required.')
      return errors
    },
    nameErrors () {
      const errors = []
      if (!this.$v.newResearchDoc.name.$dirty) return errors
      !this.$v.newResearchDoc.name.maxLength && errors.push('Name must be at most 100 characters long')
      return errors
    }
  },
  data () {
    return {
      newResearchDoc: {},
      creating: false
    }
  },
  watch: {
    // whenever question changes, this function will run
    value: function (newValue) {
      this.$v.$reset()
      if (newValue === true) {
        this.resetDialog()
      }
    }
  },
  methods: {
    resetDialog: function() {
      this.creating = false
      this.newResearchDoc = {id: this.genGUID(), name: ''}
      this.$nextTick(() => { this.$v.$reset() })
    },
    createNewResearchDoc: async function () {

      this.creating = true

      const token = firebase.auth().currentUser && (await firebase.auth().currentUser.getIdToken())
      const postNewOptionsURL = `${Constants.API_BASE_PATH}/decisions/${this.decisionId}/research`
      this.newResearchDoc.decisionTaxon = this.decisionTaxon

      const res = await axios.post(postNewOptionsURL, this.newResearchDoc, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })

      if (res && res.status === 200) {

        if (res.data && res.data.researchDocId) {
          this.newResearchDoc.id = res.data.researchDocId
        }

        // Notify the world we created a new option model
        this.$emit('onSaved', this.newResearchDoc)
        this.$nextTick(() => { this.$v.$reset() })
        // Close the new option type dialog
        this.dialog = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
